import React from 'react'
import { variables } from '../../ddk/explorer/theme'
import { useTheme } from '@material-ui/core'

const VarIcon = ({ variabilityLevel }) => {
  const theme = useTheme()
  const backgroundFill =
    theme.extras.variability.backgroundFill[
      variabilityLevel - 1
    ]
  const iconFill =
    theme.extras.variability.iconFill[variabilityLevel - 1]

  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="8.5"
        cy="8.5"
        r="8.5"
        fill={backgroundFill}
      />
      <ellipse
        cx="8.43163"
        cy="12.54"
        rx="1.00877"
        ry="1.00877"
        fill="#275879"
      />
      <path
        d="M7.69849 3.34277H9.16488L8.9879 10.025H7.87546L7.69849 3.34277Z"
        fill={iconFill}
      />
    </svg>
  )
}

export default VarIcon
